import EsusView from 'components/esus/EsusView'

export default function FichaCadastroIndividualView() {
  return <EsusView url='/pec/user/cds/cadastroIndividual' />
}
